import React from 'react';
import { useHubCheckinContext } from '../../contexts/HubCheckinProvider';
import { Box } from '@primer/react';
import Button from '../../components/ui/button';

const ConnectingIcon = () => {
    return (
        <Box sx={{
            width: "16px"
        }}>
            <svg aria-label="currently running" width="100%" height="100%" fill="none" viewBox="0 0 16 16" className="anim-rotate" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" stroke="#DBAB0A" stroke-width="2" d="M3.05 3.05a7 7 0 1 1 9.9 9.9 7 7 0 0 1-9.9-9.9Z" opacity=".5"></path>
                <path fill="#DBAB0A" fill-rule="evenodd" d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" clip-rule="evenodd"></path>
                <path fill="#DBAB0A" d="M14 8a6 6 0 0 0-6-6V0a8 8 0 0 1 8 8h-2Z"></path>
            </svg>
        </Box>
    )
}

const ConnectedIcon = () => {
    return (
        <Box sx={{
            width: "16px"
        }}>
            <svg aria-label="currently running" width="100%" height="100%" fill="none" viewBox="0 0 16 16" className="anim-zoom-in-zoom-out" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" stroke="green" stroke-width="2" d="M3.05 3.05a7 7 0 1 1 9.9 9.9 7 7 0 0 1-9.9-9.9Z" opacity="1"></path>
                <path fill="green" fill-rule="evenodd" d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" clip-rule="evenodd"></path>
                <path fill="green" d="M14 8a6 6 0 0 0-6-6V0a8 8 0 0 1 8 8h-2Z"></path>
            </svg>
        </Box>
    )
}


const LiveStatus = () => {
    const { _isConnected } = useHubCheckinContext();
    return (
        <Box>
            <Button
                leadingVisual={_isConnected ? ConnectedIcon : ConnectingIcon}
                variant={_isConnected ? "default" : "danger"}
                size='medium'
            >
                {_isConnected ? "Live" : "Connecting"}
            </Button>
        </Box>
    );
};

export default LiveStatus;